import { render } from "./SVGBar.vue?vue&type=template&id=e46fe2ce"
import script from "./SVGBar.vue?vue&type=script&lang=js"
export * from "./SVGBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__